import React, { useEffect } from 'react';
import { Table, Button, Card, Spinner, Form, Pagination, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchDocuments,
  deleteDocument,
  setPage,
  setFilterType,
} from '../features/documentSlice';
import { saveAs } from 'file-saver';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

const DocumentList = () => {
  const dispatch = useDispatch();
  const { list, currentPage, totalPages, filterType, loading } = useSelector((state) => state.documents);
  const token = useSelector((state) => state.auth.token);

  useEffect(() => {
    dispatch(fetchDocuments({ token, type: filterType, page: currentPage }));
  }, [dispatch, token, filterType, currentPage]);

  const handleDelete = (id) => {
    if (window.confirm('Delete this document?')) {
      dispatch(deleteDocument({ id, token }));
    }
  };

  const handleFilterChange = (e) => {
    dispatch(setFilterType(e.target.value));
  };

  const handlePageChange = (pageNum) => {
    dispatch(setPage(pageNum));
  };

  const exportCSV = () => {
    const csv = [
      ['Title', 'Type', 'Uploaded'],
      ...list.map(doc => [doc.title, doc.source_type, new Date(doc.created_at).toLocaleString()])
    ]
      .map(row => row.join(','))
      .join('\n');

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, 'training_documents.csv');
  };

  const exportPDF = () => {
    const doc = new jsPDF();
    autoTable(doc, {
      head: [['Title', 'Type', 'Uploaded']],
      body: list.map(doc => [
        doc.title,
        doc.source_type,
        new Date(doc.created_at).toLocaleString()
      ]),
    });
    doc.save('training_documents.pdf');
  };

  return (
    <Card className="p-3 shadow-sm">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5>Uploaded Documents</h5>
        <div>
          <Button size="sm" className="me-2" onClick={exportCSV}>Export CSV</Button>
          <Button size="sm" variant="dark" onClick={exportPDF}>Export PDF</Button>
        </div>
      </div>

      <Row className="mb-3">
        <Col md={4}>
          <Form.Select value={filterType} onChange={handleFilterChange}>
            <option value="">All Types</option>
            <option value="TEXT">Text</option>
            <option value="URL">URL</option>
            <option value="PDF">PDF</option>
            <option value="CSV">CSV</option>
          </Form.Select>
        </Col>
      </Row>

      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Title</th>
            <th>Type</th>
            <th>Uploaded</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr><td colSpan="4" className="text-center"><Spinner animation="border" /></td></tr>
          ) : list.length === 0 ? (
            <tr><td colSpan="4" className="text-center">No documents found</td></tr>
          ) : (
            list.map((doc) => (
              <tr key={doc.id}>
                <td>{doc.title}</td>
                <td>{doc.source_type}</td>
                <td>{new Date(doc.created_at).toLocaleString()}</td>
                <td>
                  <Button variant="danger" size="sm" onClick={() => handleDelete(doc.id)}>
                    Delete
                  </Button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>

      {/* Pagination */}
      {totalPages > 1 && (
        <Pagination className="justify-content-center">
          {[...Array(totalPages)].map((_, i) => (
            <Pagination.Item
              key={i + 1}
              active={currentPage === i + 1}
              onClick={() => handlePageChange(i + 1)}
            >
              {i + 1}
            </Pagination.Item>
          ))}
        </Pagination>
      )}
    </Card>
  );
};

export default DocumentList;
